import { Component, Inject } from '@angular/core';
import { MATERIAL_IMPORTS } from '../../../shared/material/material';
import { DatePipe, NgClass } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Atencion } from '../../../pages/pacientes/pacientes';
import { InicioAtencionService } from '../inicio-atencion.service';
import { AuthService } from '../../../core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard-atendidos',
  imports: [...MATERIAL_IMPORTS, NgClass, DatePipe],
  templateUrl: './dashboard-atendidos.html',
  styleUrl: './dashboard-atendidos.scss',
})
export class DashboardAtendidos {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { atendidos: Atencion[] },
    private dialogRef: MatDialogRef<DashboardAtendidos>,
    private inicioAtencionService: InicioAtencionService,
    private authService: AuthService,
  ) {}

  retomarConsulta(atencion: Atencion): void {
    // Solo se pueden retomar consultas que sigan activas.
    if (atencion.estado !== 'EN_ATENCION') {
      return;
    }

    const usuario = this.authService.getUser();

    if (!usuario?.id) {
      Swal.fire({
        icon: 'error',
        title: 'Sesión no disponible',
        text: 'No se pudo identificar al médico que inició sesión.',
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    const medicoId = atencion.medico?.id;

    // Si la atención no tiene médico asociado, no permitir retomarla.
    if (!medicoId) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede retomar la consulta',
        text: 'Esta atención no tiene registrado al médico responsable. Contacta al administrador.',
        confirmButtonColor: '#24575A',
      });
      return;
    }

    // Comparar el médico responsable con el usuario autenticado.
    if (String(medicoId) !== String(usuario.id)) {
      Swal.fire({
        icon: 'warning',
        title: 'Consulta asignada a otro médico',
        text: 'Solo el médico que inició esta atención puede retomarla. No se ha realizado ningún cambio.',
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    // El médico responsable sí puede retomarla.
    this.inicioAtencionService.abrirConsulta(atencion, () => this.dialogRef.close());
  }

  etiquetaEstado(estado: Atencion['estado']): string {
    switch (estado) {
      case 'EN_ATENCION':
        return 'En consulta';
      case 'ATENDIDO':
        return 'Finalizada';
      case 'CANCELADO':
        return 'Cancelada';
      case 'EN_ESPERA':
        return 'En espera';
      default:
        return estado;
    }
  }
}
